import React from "react";
import useApplyDesignSystemStylesheet from "./useApplyDesignSystemStylesheet";

const WithDesignSystemStylesheet = ({ children }) => {
  useApplyDesignSystemStylesheet();
  return <>{children}</>;
};

export default WithDesignSystemStylesheet;
